import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Home from "../modules/Home/Home";
import LandingPage from "../modules/LandingPage/LandingPage";
import { AppDispatch, RootState } from "../store";
import { useDispatch, useSelector } from "react-redux";
import { podActions } from "../store/slices/PODSlice";

const BASE_URL = "/landing";
const POD_URL = "pod";

const Resource = () => {
  const { resourceName, podId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  if (resourceName) {
    dispatch(podActions.setResourceName(resourceName));
    localStorage.setItem("resourceName", resourceName);
  }
  return (
    <Navigate to={`${BASE_URL}/${resourceName}/${POD_URL}/${podId}`} replace />
  );
};

const Router = () => {
  const resourceName = useSelector(
    (state: RootState) => state.pod.resourceName
  );

  return (
    <Routes>
      <Route
        path={`${BASE_URL}/:resourceName/${POD_URL}/:podId`}
        element={<Resource />}
      />
      <Route path='*' element={<Navigate to={BASE_URL} replace />} />
      <Route
        path={`${BASE_URL}/${resourceName}/${POD_URL}/:podId`}
        element={<Home />}>
        <Route index element={<LandingPage />} />
      </Route>
    </Routes>
  );
};

export default Router;
